import { PhoneNumberDirection } from '@app/core/interfaces/c5/phone-number-direction';
import { ScreenNumber } from '@app/core/interfaces/screen-number';

export function availableAsScreenNumberForSystemRange(screenNumber: ScreenNumber): boolean {
  return screenNumber.dir === PhoneNumberDirection.IN_OUT && screenNumber.netNumber;
}
